export default __webpack_public_path__ + "static/media/flagFilled.8238a973.svg";